module.exports = __webpack_public_path__ + "img/chemical_hazerd.ce18ee31.svg";